<template>
<div class="sidebar" :data-color="activeColor" :data-background-color="backgroundColor">
    <div class="logo">
        <a href="#" class="simple-text logo-mini" target="_blank">
            <div class="">
                <img class="image-logo" :src="logo" />
            </div>
        </a>
        <a href="#" class="simple-text logo-normal" target="_blank">
            <template>{{ title }}</template>
        </a>
        
        <div class="navbar-minimize">            
            <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
                <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
                <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
            </md-button>
        </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
        <slot></slot>
        <md-list class="nav">
            <slot name="links">
                <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link">
                    <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink">
                    </sidebar-item>
                </sidebar-item>
            </slot>
        </md-list>
    </div>
</div>
</template>

<script>
export default {
    name: "sidebar",
    data() {
        return {
            title: "POP CARD",
            logo: "./img/logo2.png"
        }
    },
    
    props: {
        activeColor: {
            type: String,
            default: "site",
            validator: value => {
                let acceptedValues = [
                    "",
                    "purple",
                    "site",
                    "azure",
                    "green",
                    "orange",
                    "danger",
                    "rose"
                ];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        backgroundColor: {
            type: String,
            default: "black",
            validator: value => {
                let acceptedValues = ["", "black", "white", "red"];
                return acceptedValues.indexOf(value) !== -1;
            }                
        },
        sidebarLinks: {
            type: Array,
            default: () => []
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },  

    provide() {
        return {
            autoClose: this.autoClose
        };
    },
    methods: {
        minimizeSidebar() {
            if (this.$sidebar) {
                this.$sidebar.toggleMinimize();
            }
        }
    },
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false;
        }
    }
};
</script>

<style>
@media (min-width: 992px) {

    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }

    .navbarMinimize {
        color: #fff !important;
    }

    .logo-mini {
        margin-left: 1px !important;
        margin-top: -14px;
        width: 80px !important;
    }

    .logo-normal {
        margin-left: 1px !important;
        margin-top: -12px;
    }

    .navbar-minimize {
        margin-left: 1px !important;
        margin-top: -12px;
    }

}
</style>
